import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=32cc7ce8&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=ts"
export * from "./voucher.vue?vue&type=script&lang=ts"
import style0 from "./voucher.vue?vue&type=style&index=0&id=32cc7ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc7ce8",
  null
  
)

export default component.exports